import React from 'react'
import ProductCarousel from "./productCarousel";
import VerticalCarousel from "./VerticalCarousel";


export const DetailImg = React.memo(({ appData: { servicedata }, appData: { pagecontextdata } }) => {
  const imgList = servicedata?.productData?.altImages?.length > 0 ? servicedata?.productData?.altImages : [{altImageUrl:servicedata?.productData?.productImageUrl, altImageDisplayName: servicedata?.productData?.displayName}]
  return (<>
      <ProductCarousel data={imgList}/>
      <VerticalCarousel data={imgList} />
  </>)
})
